import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBb9MDKyLHvPqtcszu_eeMZSge7XepPXQY",
  authDomain: "eod-logger.firebaseapp.com",
  projectId: "eod-logger",
  storageBucket: "eod-logger.firebasestorage.app",
  messagingSenderId: "771229524735",
  appId: "1:771229524735:web:fceb27d63ce6eb7460e2ca"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;